import styled from 'styled-components';
import { DataTexto, Linha } from '../../styles/base';

export const GridContainerPrincipal = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(16em, 1fr));
  height: 100%;

  b {
    font-weight: 600;
  }
`;

export const ContainerBrancoPrincipal = styled.div`
  background-color: #fff;
  padding: 9px 16px;
  border-radius: 4px;

  hr {
    border-top-color: #DEDEDD;
  }
`;

export const ContainerBrancoSticky = styled.div`
  position: sticky;
  top: 9px;
`;

export const ContainerLateralAndamentos = styled.div`
  max-height: 120vh;
  overflow-y: auto;
  padding-right: 7px;
  
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-corner {
    background-color: #fbfaf5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dfe4ea;
  }
`;

export const PrintManifestacao = styled.div`
  height: 100vh;
  width: 100%;
  background-color: blue;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const LinhaItemManifestacao = styled.div`
  display: grid;
  font-size: 15px;
`;

export const LinhaItemManifestacaoSecretaria = styled(Linha)`
  align-items: flex-start;
  grid-gap: 5px;

  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

export const LinhaItemManifestacaoImpressao = styled(Linha)`
  justify-content: flex-end;

  @media screen and (max-width: 800px) {
    order: -1;
    align-self: flex-end;
  }
`;

export const GridArquivos = styled.div`
  display: grid;
  grid-gap: ${(props) => (props.totem ? '32px' : '24px')};
  max-height: 270px;
  overflow-y: auto;
  padding-inline: 7px;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-corner {
    background-color: #fbfaf5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dfe4ea;
  }

  @media screen and (min-width: 500px) {
    grid-template-columns: repeat(auto-fill, minmax(10em, 1fr));
  }
`;

export const BoldTitulo = styled.b`
  font-size: 15px;
`;

export const GridBotaoRps = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 4px;
  margin-block: 10px;

  @media screen and (max-width: 800px) {
    flex-wrap: wrap;
  }
`;

export const BotaoRps = styled.button`
  font-size: 15px;
  color: #fff;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  width: 35px;
  height: 35px;
  transform: scale(1);
  transition: background 0.2s ease-in, color 0.2s ease-in, border-color 0.2s ease-in, transform 0.2s cubic-bezier(0.5, 2, 0.5, 0.75);
`;

export const GridBotaoEnviarAvaliacao = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-gap: 15px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const GridContainerAndamentos = styled.div`
  display: grid;
  grid-gap: 15px;
  align-content: flex-start;
`;

export const ContainerAndamentosTitulo = styled.div`
  display: grid;
  grid-gap: 6px;
  align-items: center;
  grid-template-columns: 1fr auto;  
  justify-content: space-between;
  padding-bottom: 10px;

  small {
    font-size: 15px;
    font-weight: 600;
    line-height: normal;
  }

  ${DataTexto} {
    color: #333;
    font-size: 15px;
    font-weight: 400;
  }
`;

export const ContainerAndamentosHtml = styled.div`
  font-size: 15px;
  line-height: 25px;
  padding-block: 12px;
`;

export const ContainerAndamentos = styled.div`
  background-color: ${({ respostaFinal }) => (respostaFinal ? 'rgba(45, 204, 112, 0.15)' : 'rgba(241, 197, 14, 0.15)')};
  border-radius: 4px;
  padding: 11px 14px;
  min-height: 150px;

  > ${ContainerAndamentosTitulo} {
    border-bottom: 1px solid ${({ respostaFinal }) => (respostaFinal ? '#B0D9C1' : '#E4D8A7')};
  }

  > ${ContainerAndamentosHtml} {
    color: ${({ respostaFinal }) => (respostaFinal ? '#587E68' : '#93885D')};
  }
`;

export const ContainerInteracoes = styled(ContainerAndamentos)`
  background-color: ${({ mensagemAdmin }) => (mensagemAdmin ? '#fff' : '#f1f1f1')};

  > ${ContainerAndamentosTitulo} {
    border-bottom: 1px solid #bcbcbc;
  }

  > ${ContainerAndamentosHtml} {
    color: #222222;
  }
`;

export const RotuloPrincipalAcompanhamentos = styled.b`
  font-size: 15px;
`;
